<template>
  <div>
    <form-wizard
      color="#7367F0"
      :title="null"
      :subtitle="null"
      shape="square"
      finish-button-text="Submit"
      back-button-text="Previous"
      class="mb-3"
      @on-complete="formSubmitted"
    >

      <!-- source Cash -->
      <tab-content
        title="Sumber Kas"
        :before-change="validationForm"
      >
        <validation-observer
          ref="cashflowRules"
          tag="form"
        >
          <b-row>
            <b-col
              cols="12"
              class="mb-2"
            >
              <h5 class="mb-0">
                Sumber Kas
              </h5>
              <small class="text-muted">
                Masukan Data Sumber Kas
              </small>
            </b-col>
            <b-col md="6">
              <b-form-group
                label="Transfer Dari"
                label-for="source-cash"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Sumber Kas"
                  rules="required"
                >
                  <v-select
                    id="source-cash"
                    v-model="from.cash_id"
                    :options="cashOpt"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :state="errors.length > 0 ? false:null"
                    label="title"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                label="Jumlah"
                label-for="source-amount"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Jumlah"
                  rules="required"
                >
                  <cleave
                    id="number"
                    v-model="from.number"
                    class="form-control"
                    placeholder="Masukan Jumlah"
                    :raw="true"
                    :options="options.number"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
        </validation-observer>
      </tab-content>
      <!-- destination Cash -->
      <tab-content
        title="Kas Tujuan"
        :before-change="validationToForm"
      >
        <validation-observer
          ref="cashflowToRules"
          tag="form"
        >
          <b-row>
            <b-col
              cols="12"
              class="mb-2"
            >
              <h5 class="mb-0">
                Kas Tujuan
              </h5>
              <small class="text-muted">
                Masukan Data Kas Tujuan
              </small>
            </b-col>
            <b-col md="6">
              <b-form-group
                label="Transfer Ke"
                label-for="source-cash"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Tujuan Kas"
                  rules="required"
                >
                  <v-select
                    id="source-cash"
                    v-model="to.cash_id"
                    :options="cashOpt"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :state="errors.length > 0 ? false:null"
                    label="title"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                label="Jumlah"
                label-for="source-amount"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Jumlah"
                  rules="required"
                >
                  <cleave
                    id="number"
                    v-model="from.number"
                    class="form-control"
                    placeholder="Masukan Jumlah"
                    :raw="false"
                    readonly="true"
                    :options="options.number"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                label="Keterangan"
                label-for="source-desc"
              >
                <b-input-group>
                  <b-form-textarea
                    id="source-desc"
                    v-model="to.desc"
                  />
                </b-input-group></b-form-group>
            </b-col>
          </b-row>
        </validation-observer>
      </tab-content>

    </form-wizard>

  </div>
</template>

<script>
import { FormWizard, TabContent } from 'vue-form-wizard'
import vSelect from 'vue-select'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import {
  BRow,
  BCol,
  BFormGroup,
  BFormTextarea,
  BInputGroup,
} from 'bootstrap-vue'
import { required } from '@validations'
import Cleave from 'vue-cleave-component'
// eslint-disable-next-line import/no-extraneous-dependencies
import 'cleave.js/dist/addons/cleave-phone.us'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    FormWizard,
    TabContent,
    BRow,
    BCol,
    BInputGroup,
    BFormGroup,
    BFormTextarea,
    vSelect,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    Cleave,
  },
  data() {
    return {
      required,
      from: {
        cash_id: null,
        number: null,
      },
      to: {
        cash_id: null,
        desc: null,
      },
      cashOpt: [],
      options: {
        number: {
          numeral: true,
          numeralThousandsGroupStyle: 'thousand',
          numeralPositiveOnly: true,
        },
      },
    }
  },
  created() {
    this.$http.get('/cashmaster')
      .then(res => {
        this.cashOpt = res.data.data.map(cash => ({
          value: cash.id,
          title: cash.name,
        }))
      })
  },
  methods: {
    formSubmitted() {
      const payload = {
        from: {
          cash_id: this.from.cash_id,
          number: this.from.number,
        },
        to: {
          cash_id: this.to.cash_id,
          desc: this.to.desc,
        },
      }
      this.$http.post('/cash-flow/mutation', payload)
        .then(() => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Mutasi Sukses',
              icon: 'CheckCircleIcon',
              variant: 'success',
            },
          })
          this.$router.push({ name: 'acc-cashflow-list' })
        }).catch(err => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: err.response.data.message || 'Mutasi Gagal',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    },
    validationForm() {
      return new Promise((resolve, reject) => {
        this.$refs.cashflowRules.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    validationToForm() {
      return new Promise((resolve, reject) => {
        this.$refs.cashflowToRules.validate().then(success => {
          if (success) {
            // this.formSubmitted()
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
  },
}
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-wizard.scss';
  @import '@core/scss/vue/libs/vue-select.scss';
</style>
